/**
 * 成功注册用户
 */
<template>
    <div class="suc-user-wrapper">
      <div class="user-rank">
        <img src="~@/assets/images/bgxz.png" alt="">
        <div class="user-rank-text">
          <div v-if="userNumber">
            <div>恭喜你成为便捷青岛</div>
            <div>第{{userNumber}}名用户</div>
          </div>
          <div v-if="!userNumber">
            <div>您已经是便捷青岛用户，</div>
            <div>赶紧下载APP享受更多功能吧~</div>
          </div>
        </div>
      </div>
      <div class="list-wrapper">
        <div class="list-content">
          <div class="title">在这里，您可以</div>
          <ul class="content">
            <li
              class="item"
              v-for="(item, index) in iconData"
              :key="index"
            >
              <i class="icon" :class="item.icon"></i>
              <div>{{item.desc}}</div>
            </li>
          </ul>
          <div class="download-btn" @click="handleDownLoad">{{btnText}}</div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'sucUser',
  data () {
    return {
      title: '您已注册成功',
      btnText: '下载便捷青岛APP',
      userNumber: '10000',
      iconData: [
        {
          icon: 'icon_1',
          desc: '1.公交扫码乘车享八折优惠；'
        },
        {
          icon: 'icon_2',
          desc: '2.垃圾分类兑换信豆，赢取多重好礼；'
        },
        {
          icon: 'icon_3',
          desc: '3.互联网购药，省时省心，极速到达；'
        },
        {
          icon: 'icon_4',
          desc: '4.水电气暖，足不出户，一键缴纳；'
        },
        {
          icon: 'icon_5',
          desc: '5.注册获得信豆，享受消费抵扣特权。'
        },
        {
          icon: 'icon_6',
          desc: '更多功能，请您开启！'
        }
      ]
    }
  },
  created () {
    this.userNumber = this.$route.params.num
  },
  methods: {
    handleDownLoad () {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    }
  }
}
</script>
<style lang='scss' scoped>
  .suc-user-wrapper {
    min-height: 100vh;
    background: #f1f1f1;
  }
  .user-rank {
    position: relative;
    img {
      width: 100%;
    }
  }
  .user-rank-text {
    position: absolute;
    top: 65px;
    left: 50%;
    transform: translateX(-50%);
    div {
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      color: #fff;
      font-size: 22px;
    }
  }
  .list-wrapper {
    padding: 8px 18px 18px 18px;

  }
  .list-content {
    padding: 15px 20px;
    border-radius: 8px;
    background: #fff;
    font-size: 15px;
    .title {
      margin-bottom: 8px;
      font-size: 16px;
    }
    .item {
      display: flex;
      align-items: center;
      line-height: 2.8;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .icon {
      width: 25px;
      height: 25px;
      margin-right: 8px;
      background-size: 100%;
    }
    .icon_1 {
      background: url('~@/assets/images/gongjiao.png') no-repeat center center;
       background-size: 100%;
    }
    .icon_2 {
      background: url('~@/assets/images/laji.png') no-repeat center center;
       background-size: 100%;
    }
    .icon_3 {
      background: url('~@/assets/images/gouyao.png') no-repeat center center;
       background-size: 100%;
    }
    .icon_4 {
      background: url('~@/assets/images/jiaofei.png') no-repeat center center;
       background-size: 100%;
    }
    .icon_5 {
      background: url('~@/assets/images/xindou.png') no-repeat center center;
      background-size: 100%;
    }
    .icon_6 {
      background: url('~@/assets/images/more.png') no-repeat center center;
      background-size: 100%;
    }
    .download-btn {
      box-sizing: border-box;
      margin: 20px 0;
      padding: 10px 5px;
      background: #3782fb;
      font-size: 17px;
      color: #fff;
      text-align: center;
      border-radius: 20px;
    }
  }

</style>
